import React from "react";
import { SEARCH_TABS } from "utils/constants";
import clsx from "clsx/lite";

const SearchTabs = ({ activeTab, setActiveTab, className }) => (
	<div className={clsx("gap-4", className)}>
		{Object.values(SEARCH_TABS).map((tab) => (
			<button
				key={tab}
				className={clsx(
					"font-header p-2 w-1/2 capitalize",
					activeTab === tab ? "border-b-2 border-beige" : "pb-2.5 text-darkGray")}
				onClick={() => setActiveTab(tab)}>
				{tab}
			</button>
		))}
	</div>
);

export default SearchTabs;